import { render, staticRenderFns } from "./UploadedDocumentList.vue?vue&type=template&id=0154b338&scoped=true"
import script from "./UploadedDocumentList.vue?vue&type=script&lang=js"
export * from "./UploadedDocumentList.vue?vue&type=script&lang=js"
import style0 from "./UploadedDocumentList.vue?vue&type=style&index=0&id=0154b338&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0154b338",
  null
  
)

export default component.exports